import { cn } from '@/lib/utils'

export function NumberBadge({ value, className }: { value: number | string; className?: string }) {
  return (
    <div className={cn('flex size-6 shrink-0 items-center justify-center rounded-full bg-muted text-xs', className)}>
      {value}
    </div>
  )
}
